import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Products.css";

const products = [
  { 
    name: "Spices", 
    icon: "🌶️", 
    description: "Premium quality spices from around the world"
  },
  { 
    name: "Handicrafts", 
    icon: "🎨", 
    description: "Unique handmade items and traditional crafts"
  },
  { 
    name: "Jewelry & Gemstones", 
    icon: "💎", 
    description: "Fine jewelry and precious gemstones"
  },
  { 
    name: "Tea & Coffee", 
    icon: "☕", 
    description: "Premium tea leaves and coffee beans"
  },
  { 
    name: "Textiles", 
    icon: "🧵", 
    description: "High-quality fabrics and clothing materials"
  },
  { 
    name: "Automotive Parts", 
    icon: "🚗", 
    description: "Reliable automotive components and accessories"
  },
  { 
    name: "Fashion Accessories", 
    icon: "👜", 
    description: "Trendy fashion items and accessories"
  },
  { 
    name: "Electronics", 
    icon: "💻", 
    description: "Modern electronic devices and gadgets"
  },
  { 
    name: "Furniture", 
    icon: "🛋️", 
    description: "Quality furniture and home décor items"
  },
  { 
    name: "Organic Foods", 
    icon: "🥗", 
    description: "Fresh organic produce and natural foods"
  },
  { 
    name: "Toys & Games", 
    icon: "🎮", 
    description: "Entertainment products for all ages"
  },
  { 
    name: "Health & Beauty", 
    icon: "💄", 
    description: "Beauty products and health supplements"
  }
];

export default function Products() {
  return (
    <section id="products" className="products-section py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="section-title">Our Products</h2>
          <p className="section-subtitle">
            Connecting you with quality products from around the world
          </p>
        </div>
        
        <Row className="g-4">
          {products.map((product, index) => (
            <Col lg={4} md={6} key={index}>
              <Card className="product-card h-100">
                <Card.Body className="text-center">
                  <div className="product-icon">
                    <span className="icon-emoji">{product.icon}</span>
                  </div>
                  <Card.Title className="product-name">{product.name}</Card.Title>
                  <Card.Text className="product-description">
                    {product.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

